export default "__VITE_ASSET__7b49ca7d__"